import React from "react"

interface CalendarFormSectionProps {
  icon: React.ReactNode
  title: string
  children: React.ReactNode
  className?: string
}

// The card treatment used for every section of the Create/Edit Event and
// Reminder forms — one shared shape so Edit (which renders the same form
// component in a different modal) never drifts from Create's design.
export function CalendarFormSection({
  icon,
  title,
  children,
  className
}: CalendarFormSectionProps) {
  return (
    <div
      // shrink-0: without it, the scrollable column of sections above (which
      // sizes each child with the flex default of flex-shrink: 1) compresses
      // every card down toward its header's height instead of letting the
      // column scroll — the card's own overflow-hidden (kept for the header's
      // rounded top corners) then clipped the squeezed-out body content.
      className={`shrink-0 overflow-hidden rounded-xl border border-gray-200 ${className || ""}`}
    >
      <div
        className={
          "flex items-center gap-2 border-b border-gray-200 bg-gray-50 px-6 py-3"
        }
      >
        <span className={"text-sm text-gray-500"}>{icon}</span>
        <span className={"text-sm font-semibold text-gray-700"}>{title}</span>
      </div>
      <div className={"flex flex-col gap-5 p-6"}>{children}</div>
    </div>
  )
}
